import parse from 'html-react-parser'

export const parseHtml = (html, options) => parse(html || '', options)

export default parseHtml
